
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 19v-2h9V5.825A2.919 2.919 0 017.175 4H4l3 7c0 .833-.342 1.542-1.025 2.125-.683.583-1.508.875-2.475.875-.967 0-1.792-.292-2.475-.875S0 11.833 0 11l3-7H1V2h6.175c.2-.583.558-1.063 1.075-1.438A2.908 2.908 0 0110 0c.65 0 1.233.187 1.75.562.517.375.875.855 1.075 1.438H19v2h-2l3 7c0 .833-.342 1.542-1.025 2.125-.683.583-1.508.875-2.475.875-.967 0-1.792-.292-2.475-.875S13 11.833 13 11l3-7h-3.175A2.918 2.918 0 0111 5.825V17h9v2H0zm14.625-8h3.75L16.5 6.65 14.625 11zm-13 0h3.75L3.5 6.65 1.625 11zM10 4a.97.97 0 00.713-.287A.97.97 0 0011 3a.97.97 0 00-.287-.713A.97.97 0 0010 2a.967.967 0 00-.712.287A.968.968 0 009 3c0 .283.096.521.288.713A.967.967 0 0010 4z"}})])
          )
        }
      }
    